import { Injectable } from '@angular/core';
import { ConnectOptions, ConnectResult, ConnectService } from './connect.service';
import { ExistFile, FileBlob, FileJson } from 'src/app/service/util/file.service';
import { User } from './user.service';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  constructor(
    private connect: ConnectService
  ) { }

  /** Ctgo - 카테고리 */
  Ctgo = {
    /** 업종 */
    construction: async(_?:null, opt?:ConnectOptions):Promise<Ctgo.ConstructionResult> => {
      return await this.connect.run('/Ctgo/construction', _, opt);
    },
    /** 직종 */
    occupation: async(params:Ctgo.OccupationParams, opt?:ConnectOptions):Promise<Ctgo.OccupationResult> => {
      return await this.connect.run('/Ctgo/occupation', params, opt);
    },
    /** 국가 */
    nation: async(_?:null, opt?:ConnectOptions):Promise<Ctgo.NationResult> => {
      return await this.connect.run('/Ctgo/nation', _, opt);
    },
    /** 업체 */
    company: async(_?:null, opt?:ConnectOptions):Promise<Ctgo.CompanyResult> => {
      return await this.connect.run('/Ctgo/company', _, opt);
    }
  }

  /** GetData - 기본 데이터 가져오기 (ex:업체검색/카테고리 등) */
  GetData = {
    search_company: async(params:GetData.SearchCompanyParams, opt?:ConnectOptions):Promise<GetData.SearchCompanyResult> => {
      return await this.connect.run('/GetData/search_company', params, opt)
    },
    get_company: async(params:GetData.GetCompanyParams, opt?:ConnectOptions):Promise<GetData.GetCompanyResult> => {
      return await this.connect.run('/GetData/get_company', params, opt)
    }
  }

  /** Login - 로그인 */
  Login = {
    login: async (params:Login.loginParams, opt?:ConnectOptions):Promise<Login.loginResult> => {
      return await this.connect.run('/Login/login', params, opt)
    },
    login_session: async (_?:null, opt?:ConnectOptions):Promise<Login.loginResult> => {
      return await this.connect.run('/Login/login_session', _, opt)
    }
  }


  /** SignUp - 회원가입 */
  Signup = {
    check_id: async(params:SignUp.CheckIdParams, opt?:ConnectOptions):Promise<SignUp.CheckIdResult> => {
      return await this.connect.run('/SignUp/check_id', params, opt)
    },
    check_phone: async(params:SignUp.CheckPhoneParams, opt?:ConnectOptions):Promise<SignUp.CheckPhoneResult> => {
      return await this.connect.run('/SignUp/check_phone', params, opt)
    },
    /** 회원가입 문자 인증번호 전송하기 */
    sms_check: async(params:SignUp.SmsCheckParams, opt?:ConnectOptions):Promise<SignUp.SmsCheckResult> => {
      return await this.connect.run('/SignUp/sms_check', params, opt)
    },
    /** 회원가입 문자 인증번호 확인하기 */
    sms_auth: async(params:SignUp.SmsAuthParams, opt?:ConnectOptions):Promise<SignUp.SmsAuthResult> => {
      return await this.connect.run('/SignUp/sms_auth', params, opt)
    },
    /** 회원가입 - 근로자 */
    worker: async(params:SignUp.WorkerParams, opt?:ConnectOptions):Promise<SignUp.WorkerResult> => {
      return await this.connect.run('/SignUp/worker', params, opt)
    },
    /** 회원가입 - 사업주 */
    partner: async(params:SignUp.PartnerParams, opt?:ConnectOptions):Promise<SignUp.PartnerResult> => {
      return await this.connect.run('/SignUp/partner', params, opt)
    }
  }

  /** Work - TBM 작업정보 */
  Work = {
    /** /Work/tagging 작업구역 입장 / 퇴장하기 */
    tagging: async(params:Work​.TaggingParams, opt?:ConnectOptions):Promise<Work.ChecklistResult> => {
      return await this.connect.run('/Work/tagging', params, opt)
    },
    /** /Work/checklist TBM 확인사항 가져오기 */
    checklist: async(_?:null, opt?:ConnectOptions):Promise<Work.ChecklistResult> => {
      return await this.connect.run('/Work/checklist', _, opt)
    },
    /** /Work/notice_tbm TBM 공지사항 가져오기 */
    notice_tbm: async(_?:null, opt?:ConnectOptions):Promise<Work.NoticeTBMResult> => {
      return await this.connect.run('/Work/notice_tbm', _, opt)
    },
    /** ​/Work/notice_tbm_check TBM 공지사항 확인체크하기 */
    notice_tbm_check: async(_?:null, opt?:ConnectOptions):Promise<Work.ChecklistResult> => {
      return await this.connect.run('/Work/notice_tbm_check', _, opt)
    },
    /** ​/Work/risk_factors TBM 위험요인 가져오기 */
    risk_factors: async(_?:null, opt?:ConnectOptions):Promise<Work.RiskFactorsResult> => {
      return await this.connect.run('/Work/risk_factors', _, opt)
    },
    /** ​/Work/risk_factors_check TBM 위험요인 확인체크하기 */
    risk_factors_check: async(_?:null, opt?:ConnectOptions):Promise<Work.ChecklistResult> => {
      return await this.connect.run('/Work/risk_factors_check', _, opt)
    },
    /** ​/Work/safe_edu TBM 안전보건교육 가져오기 */
    safe_edu: async(_?:null, opt?:ConnectOptions):Promise<Work.SafeEduResult> => {
      return await this.connect.run('/Work/safe_edu', _, opt)
    },
    /** ​/Work/safe_edu_check TBM 안전보건교육 확인체크하기 */
    safe_edu_check: async(_?:null, opt?:ConnectOptions):Promise<Work.ChecklistResult> => {
      return await this.connect.run('/Work/safe_edu_check', _, opt)
    }
  }


  /** WorkPartner - TBM 작업정보 (사업주용) */
  WorkPartner = {
    /** 근로자 목록 가져오기 */
    get_my_worker: async(params:WorkPartner.getMyWorkerParams, opt?:ConnectOptions):Promise<WorkPartner.getMyWorkerResult> => {
      return await this.connect.run('/WorkPartner/get_my_worker', params, opt)
    },
    /** 승인대기 근로자 목록 가져오기 */
    get_req_worker: async(params:WorkPartner.getReqWorkerParams, opt?:ConnectOptions):Promise<WorkPartner.getReqWorkerResult> => {
      return await this.connect.run('/WorkPartner/get_req_worker', params, opt)
    },
    /** 승인대기 근로자 승인하기 */
    apply_req_worker: async(params:WorkPartner.applyReqWorkerParams, opt?:ConnectOptions):Promise<WorkPartner.applyReqWorkerResult> => {
      return await this.connect.run('/WorkPartner/apply_req_worker', params, opt)
    },
    /** 승인대기 근로자 거절하기 */
    reject_req_worker: async(params:WorkPartner.rejectReqWorkerParams, opt?:ConnectOptions):Promise<WorkPartner.applyReqWorkerResult> => {
      return await this.connect.run('/WorkPartner/reject_req_worker', params, opt)
    },
    /** TBM 현황 가져오기 */
    worker_tbmlog: async(params:WorkPartner.WorkerTbmlogParams, opt?:ConnectOptions):Promise<WorkPartner.WorkerTbmlogResult> => {
      return await this.connect.run('/WorkPartner/worker_tbmlog', params, opt)
    },
    /** /WorkPartner/get_notice_tbm - TBM 공지사항 목록 가져오기 */
    get_notice_tbm: async(params:WorkPartner.GetNoticeTbmParams, opt?:ConnectOptions):Promise<WorkPartner.GetNoticeTbmResult> => {
      return await this.connect.run('/WorkPartner/get_notice_tbm', params, opt)
    },
    /** /WorkPartner/delete_notice_tbm - TBM 공지사항 삭제하기 */
    delete_notice_tbm: async(params:WorkPartner.DeleteNoticeTbmParams, opt?:ConnectOptions):Promise<WorkPartner.DeleteNoticeTbmResult> => {
      return await this.connect.run('/WorkPartner/delete_notice_tbm', params, opt)
    },
    /** /WorkPartner/insert_notice_tbm - TBM 공지사항 등록하기 */
    insert_notice_tbm: async(params:WorkPartner.InsertNoticeTbmParams, opt?:ConnectOptions):Promise<WorkPartner.InsertNoticeTbmResult> => {
      return await this.connect.run('/WorkPartner/insert_notice_tbm', params, opt)
    },
    /** /WorkPartner/update_notice_tbm - TBM 공지사항 수정하기 */
    update_notice_tbm: async(params:WorkPartner.UpdateNoticeTbmParams, opt?:ConnectOptions):Promise<WorkPartner.UpdateNoticeTbmResult> => {
      return await this.connect.run('/WorkPartner/update_notice_tbm', params, opt)
    },
    /** /WorkPartner/notice_tbm - TBM 공지사항 상세 가져오기 */
    notice_tbm: async(params:WorkPartner.NoticeTbmParams, opt?:ConnectOptions):Promise<WorkPartner.NoticeTbmResult> => {
      return await this.connect.run('/WorkPartner/notice_tbm', params, opt)
    },
    /** 메인화면 정보 가져오기 */
    checklist: async(_?:null, opt?:ConnectOptions):Promise<WorkPartner.ChecklistResult> => {
      return await this.connect.run('/WorkPartner/checklist', _, opt)
    }
  }
}

/** common - 공통 */
export type TbmState = "ALL" | "FIN" | "NONE";

/** Ctgo - 카테고리 */
export namespace Ctgo {

  /** construction */
  export interface ConstructionResult extends ConnectResult {
    resultHash:null,
    resultListHash:ConstructionItem[]
  }
  export interface ConstructionItem {
    ctgo_construction_name:string,
    ctgo_construction_id:number
  }

  /** occupation */
  export interface OccupationParams {
    ctgo_construction_id:number
  }
  export interface OccupationResult extends ConnectResult {
    resultHash:null,
    resultListHash:OccupationItem[]
  }
  export interface OccupationItem {
    ctgo_construction_name:string,
    ctgo_construction_id:number
    ctgo_occupation_id:number,
    ctgo_occupation_name:string
  }

  /** nation */
  export interface NationResult extends ConnectResult {
    resultHash:null,
    resultListHash:NationItem[]
  }
  export interface NationItem {
    ctgo_nation_name:string,
    ctgo_nation_id:number
  }

  /** company */
  export interface CompanyResult extends ConnectResult {
    resultHash:null,
    resultListHash:CompanyItem[]
  }
  export interface CompanyItem {
    company_name:string,
    company_id:number
  }
}



/** GetData - 기본 데이터 가져오기 (ex:업체검색/카테고리 등) */
export namespace GetData {

  /** SearchCompany */
  export interface SearchCompanyParams {
    search_text:string
  }
  export interface SearchCompanyResult extends ConnectResult {
    resultHash:null,
    resultListHash:SearchCompanyItem[]
  }
  export interface SearchCompanyItem {
    company_address_detail:string,
    company_id:number,
    company_address:string,
    company_license_no:string,
    company_user_name:string,
    company_name:string
  }
  
  /** GetCompany */
  export interface GetCompanyParams {
    company_id:number
  }
  export interface GetCompanyResult extends ConnectResult {
    resultHash:GetCompanyItem,
    resultListHash:null
  }
  export interface GetCompanyItem {
    company_address_detail:string,
    company_id:number,
    company_address:string,
    company_license_no:string,
    company_user_name:string,
    company_name:string
  }
}



/** login */
export namespace Login {
  export interface loginParams {
    auth_id:string,
    auth_token:string
  }
  export interface loginResult extends ConnectResult {
    resultHash:User.UserData,
    resultListHash:null
  }

  /** 반려된 근로자 회원가입 취소하기 /Login/delete_reqworker */
  export interface DeleteReqWorkerParams {
    auth_id:string,
    auth_token:string
  }

  /** 반려된 근로자 상세보기 /Login/get_reqworker */
  export interface GetReqWorkerParams {
    auth_id:string,
    auth_token:string
  }
  export interface GetReqWorkerResult extends ConnectResult {
    resultHash:GetReqWorkerHash,
    resultListHash:null
  }
  export interface GetReqWorkerHash {
    ctgo_construction_name: string,
    company_name: string,
    auth_id: string,
    user_gender: User.UserGender,
    request_id: number,
    user_name: string,
    result_data_count: number,
    user_birth: string,
    user_career: User.CareerData[],
    ctgo_occupation_name: string,
    user_marketing_state: boolean,
    ctgo_nation_id: number,
    ctgo_occupation_id: number,
    ctgo_construction_id: number,
    user_file: [
      {
        seq_no: number,
        file_url: string,
        full_url: string,
        file_name: string,
        file_size: string,
        view_type: string,
        content_type: string
      }
    ],
    company_id: number,
    user_phone: string,
    user_privacy_state: true,
    ctgo_nation_name: string
  }

  /** 반려된 근로자 회원정보 수정하여 재가입 신청하기 /Login/update_reqworker */
  export interface UpdateReqWorkerParams {
    auth_id:string,
    auth_token:string,
    sms_token:string,
    user_name:string,
    user_phone:string,
    user_gender:string,
    user_level:User.UserLevel,
    user_birth:string,
    career_data:User.CareerData[],
    ctgo_nation_id:number,
    ctgo_construction_id:number,
    ctgo_occupation_id:number,
    files:Array<File | FileBlob>,
    file_json:FileJson
  }
}



/** SignUp - 회원가입  */
export namespace SignUp {

  /** CheckId */
  export interface CheckIdParams {
    auth_id:string
  }
  export interface CheckIdResult extends ConnectResult {
    resultHash:null,
    resultListHash:null
  }
  
  /** CheckPhone */
  export interface CheckPhoneParams {
    user_phone:string
  }
  export interface CheckPhoneResult extends ConnectResult {
    resultHash:null,
    resultListHash:null
  }
  
  /** SmsCheck */
  export interface SmsCheckParams {
    user_phone:string
  }
  export interface SmsCheckResult extends ConnectResult {
    resultHash:null,
    resultListHash:null
  }
  
  /** SmsAuth */
  export interface SmsAuthParams {
    user_phone:string,
    sms_token:string
  }
  export interface SmsAuthResult extends ConnectResult {
    resultHash:null,
    resultListHash:null
  }
  
  /** SignupWorker */
  export interface WorkerParams {
    auth_id:string,
    auth_token:string,
    user_name:string,
    user_phone:string,
    user_gender:string,
    user_birth:string,
    career_data: User.CareerData[],
    ctgo_nation_id:number,
    company_id:number,
    ctgo_construction_id:number,
    ctgo_occupation_id:number,

    user_level:User.UserLevel; // user level

    user_privacy_state:boolean,
    user_marketing_state:boolean,
    sign_check_state:boolean,
    sms_token:string,
    files:Array<File | Blob>,
    file_json:WorkerFileJson
  }
  export interface WorkerFileJson extends FileJson {
    insert:{order_no:number, view_type:WorkerViewType}[]
  }
  export type WorkerViewType = "SIGN"|"PROFILE"|"CERTIFY";
  export interface WorkerResult extends ConnectResult {}

  export interface PartnerParams {
    auth_id:string,
    auth_token:string,
    user_name:string,
    user_phone:string,
    user_gender:User.UserGender,
    user_birth:string,
    user_duty:string,
    ctgo_nation_id:number,
    company_id:number,
    user_privacy_state:boolean,
    user_marketing_state:boolean,
    sign_check_state:boolean,
    sms_token:string,
    files:Array<File | FileBlob>,
    file_json:PartnerFileJson
  }
  export interface PartnerFileJson extends FileJson {
    insert:{order_no:number, view_type:PartnerViewType}[]
  }
  export type PartnerViewType = "SIGN"|"PROFILE";
  export interface PartnerResult extends ConnectResult {}
}


/** UserInfo - 회원정보 */
export namespace UserInfo {
  export interface GetWorkerHash {
    ctgo_nation_name: string,
    ctgo_occupation_name: string,
    user_id: number,
    user_career: [
      {
        end_date: string,
        start_date: string,
        working_name: string,
        working_company: string
      }
    ],
    ctgo_occupation_id: number,
    user_marketing_state: boolean,
    user_gender: User.UserGender,
    user_level: User.UserLevel,
    user_phone: string,
    tbm_data: User.TbmDataWorker,
    user_file: Array<{
      seq_no: number,
      file_url: string,
      full_url: string,
      file_name: string,
      file_size: string,
      view_type: "PROFILE" | "SIGN" | "CERTIFY",
      content_type: string
    }>,
    user_birth: string,
    auth_id: string,
    company_id: number,
    user_privacy_state: boolean,
    ctgo_nation_id: number,
    result_data_count: number,
    user_name: string,
    company_name: string,
    ctgo_construction_name: string,
    ctgo_construction_id: number,
    manager_name: string,
    work_name: string
  }
  export interface GetWorkerResult extends ConnectResult {
    resultHash:GetWorkerHash,
    resultListHash:null
  }

  export interface UpdateWorkerDataParams {
    user_name: string,
    user_gender: User.UserGender,
    user_level: User.UserLevel,
    user_birth: string,
    career_data: User.CareerData[],
    ctgo_nation_id: number,
    ctgo_construction_id: number,
    ctgo_occupation_id: number,
    files: Array<File | FileBlob>,
    file_json: FileJson
  }
  /** 나의 작업 이력 가져오기 Hash */

  export interface GetWorkHistHash {
    work_date: string, // 일자
    inside_time: string, // 들어간시간
    outside_time: string, // 나간시간
    company_name: string, // 업체명
    ctgo_construction_name: string, // 직종
    ctgo_occupation_name: string, // 직종
    manager_name: '', // 추가
    work_name: '' // 추가
  }
  export interface GetWorkHistResult extends ConnectResult {
    resultHash:null,
    resultListHash:GetWorkHistHash[]
  }

  /** 앱공지사항 가져오기 */
  export interface GetNoticeAppHash {
    notice_app_id: number, // ID
    notice_app_title: string, // 공지제목
    reg_date: string, // 등록일
  }
  export interface GetNoticeAppResult extends ConnectResult {
    resultHash:null,
    resultListHash:GetNoticeAppHash[]
  }
  export interface GetNoticeAppDetailHash {
    notice_app_id: number, // ID
    notice_app_title: string, // 공지제목
    notice_app_start_date: string, // 기간~
    notice_app_end_date: string, // ~기간
    reg_date: string, // 등록일
    notice_app_text: string // 공지내용,
    notice_app_files:any,
    user_name: string
  }
  export interface GetNoticeAppDetailResult extends ConnectResult {
    resultHash:GetNoticeAppDetailHash,
    resultListHash:null
  }
}





/** Work - TBM 작업정보 */
export namespace Work {
  export interface ChecklistHash {
    inside_state:number, // 태깅여부
    read_notice_tbm:number, // tbm 공지사항 확인여부 
    read_safe_edu:number, // 안전교육 확인여부
    read_risk_factors:number, // 위험요인 확인여부
    outside_state:number // 퇴장여부 (퇴장중이면 다시 입장가능해야함)
    notice_app: Array<{
      notice_app_id: number,
      notice_app_title: string
    }>,
    notice_emergency: Array<{
      notice_emg_id: number,
      notice_emg_title: string,
      notice_emg_text: string
    }>
  }
  export interface ChecklistResult extends ConnectResult {
    resultHash:ChecklistHash,
    resultListHash:null
  }

  /** /Work/tagging 작업구역 입장 / 퇴장하기 */
  export interface TaggingParams {
    inside_type:"NFC" | "QR",
    inside_key:any
  }

  /** /Work/checklist TBM 확인사항 가져오기 */
  export interface ChecklistParams {
    search_text:string,
    ctgo_construction_ids: number[],
    ctgo_occupation_ids: number[]
  }

  /** /Work/notice_tbm TBM 공지사항 가져오기 */
  export interface NoticeTBMResult extends ConnectResult {
    resultHash:null,
    resultListHash:NoticeTBMHash[]
  }
  export interface NoticeTBMHash {
    notice_tbm_id:number, // ID
    notice_tbm_title:string, // 공지제목
    notice_tbm_files: ExistFile[],
    notice_tbm_text:string, // 공지내용
    user_name:string
  }

  /** ​/Work/notice_tbm_check TBM 공지사항 확인체크하기 */

  /** ​/Work/risk_factors TBM 위험요인 가져오기 */
  export interface RiskFactorsResult extends ConnectResult {
    resultHash:null,
    resultListHash:RiskFactorsHash[]
  }
  export interface RiskFactorsHash {
    risk_factors_id:number, // ID
    ctgo_construction_id:number, // 업종ID
    ctgo_occupation_id:number, // 직종ID
    ctgo_construction_name:string, // 업종명
    ctgo_occupation_name:string, // 직종명
    risk_factors:string,
    risk_factors_files: Array<{
      file_url: string, // url
      file_name: string, // 파일명
      file_size: string, // 사이즈 
      content_type: string // 콘텐츠타입
    }>,
    risk_factors_plan: "1" // 위험요인 감소대책
  }

  /** ​/Work/risk_factors_check TBM 위험요인 확인체크하기 */

  /** ​/Work/safe_edu TBM 안전보건교육 가져오기 */
  export interface SafeEduResult extends ConnectResult {
    resultHash:null,
    resultListHash:SafeEduHash[]
  }
  export interface SafeEduHash {
    safe_edu_id:number, // ID
    safe_edu_title:string, // 안전보건교육 제목
    ctgo_construction_id:number, // 업종ID
    ctgo_occupation_id:number, // 직종ID
    ctgo_construction_name:string, // 업종명
    ctgo_occupation_name:string, // 직종명
    safe_edu_files: ExistFile[],
    safe_edu_text:string // 안전보건교육 내용
  }

  /** 모든 TBM 공지사항 가져오기 */
  export interface NoticeTbmAllResult extends ConnectResult {
    resultHash:null,
    resultListHash:NoticeTbmAllHash[]
  }
  export interface NoticeTbmAllHash {
    notice_tbm_id: number, // ID
    notice_tbm_title: string, // 공지제목
    notice_tbm_start_date: string, // 기간
    notice_tbm_end_date: string // 기간
  }

  /** TBM 공지사항 가져오기 상세 */
  export interface NoticeTbmDetailResult extends ConnectResult {
    resultHash:NoticeTbmDetailHash,
    resultListHash:null
  }
  export interface NoticeTbmDetailHash {
    notice_tbm_id: number, // ID
    notice_tbm_title: string, // 공지제목
    notice_tbm_files: Array<{
      file_url: string, // url
      file_name: string, // 파일명
      file_size: string, // 사이즈 
      content_type: string // 콘텐츠타입
    }>,
    notice_tbm_text: string // 공지내용
    user_name: string
  }
}


/** WorkPartner - TBM 작업정보 (사업주용) */
export namespace WorkPartner {
  /** getMyWorker */
  export interface getMyWorkerParams {
    ctgo_construction_ids: number[],
    ctgo_occupation_ids: number[],
    search_text:string,
    safety_state:boolean
  }
  export interface getMyWorkerResult extends ConnectResult {
    resultHash:null,
    resultListHash:getMyWorkerHash[]
  }
  export interface getMyWorkerHash {
    user_id:number, // ID
    user_name:string, // 이름
    auth_id:number, // 아이디ID
    ctgo_construction_id:number, // 업종ID
    ctgo_occupation_id:number, // 직종ID
    reg_date:string, // 가입일
    ctgo_construction_name:string, // 업종명
    ctgo_occupation_name:string // 직종명
    user_level:User.UserLevel; // user level
  }
  /** getMyWorker */
  export interface getReqWorkerParams {
    ctgo_construction_ids: number[],
    ctgo_occupation_ids: number[],
    search_text:string,
    safety_state:boolean
  }
  export interface getReqWorkerResult extends ConnectResult {
    resultHash:null,
    resultListHash:getReqWorkerHash[]
  }
  export interface getReqWorkerHash {
    user_id:number, // ID
    user_name:string, // 이름
    user_level:User.UserLevel,
    auth_id:number, // 아이디ID
    ctgo_construction_id:number, // 업종ID
    ctgo_occupation_id:number, // 직종ID
    reg_date:string, // 가입일
    ctgo_construction_name:string, // 업종명
    ctgo_occupation_name:string // 직종명
    request_id:number // 요청ID
  }
  /** applyReqWorker */
  export interface applyReqWorkerParams {
    request_id:number
  }
  export interface applyReqWorkerResult extends ConnectResult {}
  /** rejectReqWorker */
  export interface rejectReqWorkerParams {
    request_id:number,
    reject_text:string
  }
  export interface rejectReqWorkerResult extends ConnectResult {}
  /** WorkerTbmlog - TBM 현황 가져오기 */
  export interface WorkerTbmlogParams {
    tbm_state:TbmState,
    search_text:string,
    search_date:string,
    ctgo_construction_ids: number[],
    ctgo_occupation_ids: number[]
    safety_state:boolean
  }
  export interface WorkerTbmlogResult extends ConnectResult {
    resultHash:null,
    resultListHash:WorkerTbmlogHash[]
  }
  export interface WorkerTbmlogHash {
    ctgo_construction_id:number, // 업종 ID
    outside_time:string, // 퇴장시간
    inside_time:string, // 입장시간
    read_safe_edu:number, // 0 = 안전교육안함 / 1 = 함
    ctgo_occupation_id:number, // 직종 ID
    ctgo_occupation_name:string, // 직종명
    read_risk_factors:number, // 0 = 위험요인안봄 / 1 = 봄
    read_notice_tbm:number, // 0 = tbm공지안봄 / 1 = 봄
    user_phone:string, // 연락처
    auth_id:string, // ID
    ctgo_construction_name:string, // 직종명
    user_id:number, // 유저ID
    user_name:string // 유저이름
    user_level:User.UserLevel
  }
  /** /WorkPartner/get_notice_tbm - TBM 공지사항 목록 가져오기 */
  export interface GetNoticeTbmParams {
    search_text:string
  }
  export interface GetNoticeTbmResult extends ConnectResult {
    resultHash:null,
    resultListHash:GetNoticeTbmHash[]
  }
  export interface GetNoticeTbmHash {
    notice_tbm_id:number, // ID
    notice_tbm_title:string, // 공지제목
    notice_tbm_start_date:string, // 기간~
    notice_tbm_end_date:string, // ~기간
    notice_tbm_text:string, // 공지내용
    user_id:number,
    user_level:string,
    reg_user_id: number
  }
  /** /WorkPartner/delete_notice_tbm - TBM 공지사항 삭제하기 */
  export interface DeleteNoticeTbmParams {
    notice_tbm_id:number, // ID
  }
  export interface DeleteNoticeTbmResult extends ConnectResult {
    resultHash:null,
    resultListHash:null
  }
  /** /WorkPartner/insert_notice_tbm - TBM 공지사항 등록하기 */
  export interface InsertNoticeTbmParams {
    notice_tbm_title:string,
    notice_tbm_text:string,
    notice_tbm_start_date:string,
    notice_tbm_end_date:string,
    notice_tbm_construction:{
      ctgo_construction_id: number;
      ctgo_occupation_id?: number | null;
      occupation_list?: any[];
    }[];
    files:Array<File | FileBlob>,
    /** view-type - File */
    file_json:FileJson
  }
  export interface InsertNoticeTbmResult extends ConnectResult {
    resultHash:null,
    resultListHash:null
  }
  /** /WorkPartner/update_notice_tbm - TBM 공지사항 수정하기 */
  export interface UpdateNoticeTbmParams {
    notice_tbm_id:number,
    notice_tbm_title:string,
    notice_tbm_text:string,
    notice_tbm_start_date:string,
    notice_tbm_end_date:string,
    notice_tbm_construction: {
      ctgo_construction_id: number;
      ctgo_occupation_id?: number | null;
      occupation_list?: any[];
    }[];
    files:Array<File | FileBlob>,
    /** view-type - File */
    file_json:FileJson
  }
  export interface UpdateNoticeTbmResult extends ConnectResult {
    resultHash:null,
    resultListHash:null
  }
  /** /WorkPartner/notice_tbm - TBM 공지사항 상세 가져오기 */
  export interface NoticeTbmParams {
    notice_tbm_id:number
  }
  export interface NoticeTbmResult extends ConnectResult {
    resultHash:NoticeTbmHash,
    resultListHash:null
  }
  export interface NoticeTbmHash {
    notice_tbm_id:number, // ID
    notice_tbm_title:string, // 공지제목
    notice_tbm_start_date:string, // 기간~
    notice_tbm_end_date:string, // ~기간
    reg_date:string, // 등록일
    user_id:number, // 작성자 ID
    user_name:string, // 작성자
    user_level:string,
    reg_user_id:number, // 최초작성자 ID
    notice_tbm_files: Array<NoticeTbmFile>,
    notice_tbm_text:string, // 공지내용,
    notice_tbm_construction: Array<{
      ctgo_construction_id:number,
      ctgo_construction_name:string,
      ctgo_occupation_id?: number, // 추가
      ctgo_occupation_name?: string, // 추가
      occupation_list?: any[] // 추가
    }>

  }
  export interface NoticeTbmFile {
    notice_tbm_id:number, // notice_tbm_id
    seq_no:number, // seq_no
    order_no:number, // order_no
    file_url:string, // url
    file_name:string, // 파일명
    file_size:string, // 사이즈 
    content_type:string // 콘텐츠타입
  }
  /** checklist - 사업주 메인화면 카드 정보 */
  export interface ChecklistResult extends ConnectResult {
    resultHash:ChecklistHash,
    resultListHash:null
  }
  export interface ChecklistHash {
    tbm_percent:number,
    affiliate_tbm_data: {
      inside_count:number,
      result_data_count:number,
      tbm_percent:number,
      worker_count:number
    },
    request_reg_count:number,
    inside_count:number,
    result_data_count:number,
    worker_count:number,
    notice_app: Array<{
      notice_app_id: number,
      notice_app_title: string,
      notice_app_text: string
    }>,
    notice_emergency: Array<{
      notice_emg_id: number,
      notice_emg_title: string,
      notice_emg_text: string
    }>
  }
}
